import { createStyles, fade, Theme } from '@material-ui/core'

export const useKpiItemStyles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: '1 1 260px',
      minWidth: 260,
      maxWidth: 320,
      padding: theme.spacing(2.5, 3),
      borderRadius: theme.spacing(1.5),
      border: '1px solid rgba(0,0,0,0.12)',
      backgroundColor: theme.palette.background.paper,
      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 100%',
        maxWidth: '100%'
      }
    },
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        borderColor: theme.palette.primary.light
      },
      '&:active': {
        transform: 'translateY(0px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }
    },
    // Estado activo - relleno con color primario (mismo contraste que SettlementKpiItem)
    active: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      '& $valueText': {
        color: `${theme.palette.primary.contrastText} !important`
      },
      '& $descriptionText': {
        color: `${theme.palette.primary.contrastText} !important`,
        opacity: 0.85
      },
      '& $iconBadge': {
        backgroundColor: `${fade(theme.palette.primary.contrastText, 0.18)} !important`,
        color: `${theme.palette.primary.contrastText} !important`
      },
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 30px rgba(0,0,0,0.3)'
      }
    },
    content: {
      display: 'flex',
      flexDirection: 'column'
    },
    valueText: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.1,
      color: theme.palette.text.primary,
      transition: 'color 0.25s ease'
    },
    descriptionText: {
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      marginTop: theme.spacing(0.5),
      transition: 'color 0.25s ease'
    },
    iconBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 64,
      height: 64,
      borderRadius: '50%',
      backgroundColor: fade(theme.palette.primary.main, 0.12),
      color: theme.palette.primary.main,
      fontSize: '1.625rem',
      marginRight: theme.spacing(2),
      transition: 'background-color 0.25s ease, color 0.25s ease'
    },
    skeleton: {
      borderRadius: theme.spacing(0.5)
    },
    // variante "hero" - un único KPI destacado, apilado y centrado (ver leftContent de atlasAccessPage)
    rootHero: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      border: 'none',
      backgroundColor: 'transparent',
      padding: theme.spacing(3)
    },
    iconBadgeHero: {
      width: 72,
      height: 72,
      fontSize: '1.75rem',
      marginRight: 0,
      marginBottom: theme.spacing(1.5)
    },
    valueTextHero: {
      fontSize: '2.75rem',
      textAlign: 'center'
    },
    descriptionTextHero: {
      fontSize: '0.875rem',
      textAlign: 'center'
    }
  })
